import Vue from "vue";
import Vuex from "vuex";
import sessionVuexModule from "./session";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    session: sessionVuexModule
  }
});
